import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Timer } from './Timer'
import { EventDate } from './EventDate'
import { useStore } from '../../hooks/useStore'
import { useEventById } from '../../hooks/use-event-by-id'
import { setShowAskNameDialog } from '../../reducers/uiSlice'
import { useAddToCalendar } from '../../hooks/useAddToCalendar'

const CountdownTimer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { addToCalendar } = useAddToCalendar()
  const { data: event, isLoading: isLoadingEvent } = useEventById()
  const { isLoading: isLoadingStore, data: store } = useStore()
  const {
    storeConfigurations: {
      features: { chatLogin },
    },
  } = store

  const handleRegisterClick = () => {
    if (chatLogin.scheduledRegistration) {
      dispatch(
        setShowAskNameDialog({
          open: true,
          allowCancel: true,
          title: t('countdown.registerTitle'),
          fromScheduled: true,
        }),
      )
      return
    }
    addToCalendar()
  }

  return (
    <CountdownContainer data-test="countdown-container">
      <Timer
        key={event.startAt ?? event.joinAt}
        finishAt={event.secondsUntilStart ?? event.secondsUntilJoin}
      />
      <EventDate onClick={handleRegisterClick} disabled={isLoadingEvent || isLoadingStore}>
        {chatLogin.scheduledRegistration
          ? t('countdown.registerButton').toUpperCase()
          : t('countdown.addToCalendarButton').toUpperCase()}
      </EventDate>
    </CountdownContainer>
  )
}

const CountdownContainer = styled.div`
  /* border-box: la app corre en content-box (default); sin esto,
     width:100% + padding desborda y genera scrollbar horizontal en Windows */
  box-sizing: border-box;
  width: 100%;
  max-width: 26rem;
  padding: 0 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export { CountdownTimer }
